import { render } from "./AppSkeletonFolder.vue?vue&type=template&id=2477ba6e&scoped=true&ts=true"
import script from "./AppSkeletonFolder.vue?vue&type=script&lang=ts"
export * from "./AppSkeletonFolder.vue?vue&type=script&lang=ts"

import "./AppSkeletonFolder.vue?vue&type=style&index=0&id=2477ba6e&scoped=true&lang=sass"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2477ba6e"]])

export default __exports__